<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="h-100p overflow-y-scroll w-100 pan-result-main">
        <div class="custom_container pan-result-layout">
            <div class="search-container">
                <!-- Top bar -->
                <div class="search-header">
                    <div class="header-left">
                        <button class="back-button" (click)="onBackButtonClick()">
                            <i class="bi bi-arrow-left"></i>
                            <span>Back</span>
                        </button>
                    </div>
                    <div class="header-center">
                        <h1 class="search-query">{{ phonepeUpiData?.vpa || selectedSearchResult?.searched_upi || 'UPI to Bank' }}</h1>
                    </div>
                </div>

                <!-- Loader -->
                <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-main-color">Fetching results, please wait...</p>
                </div>

                <div class="container container--pan-result my-3 my-md-4 px-2 px-sm-3" *ngIf="!isLoadingResults && noRecords">
                    <div class="alert alert-warning mb-0">No UPI to Bank records found for this search.</div>
                </div>

                <!-- Search Results -->
                <div class="container container--pan-result my-3 my-md-4 px-2 px-sm-3" *ngIf="!isLoadingResults && phonepeUpiData">
                    <div class="main-pan-details-wrapper">

                        <!-- Identity -->
                        <div class="details-box personal-details-box" *ngIf="hasIdentitySection">
                            <h5 class="details-heading"><i class="bi bi-person-vcard"></i>Identity</h5>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.name)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Name</p>
                                        <p>{{ phonepeUpiData.name }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.vpa)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">VPA</p>
                                        <p>{{ phonepeUpiData.vpa }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.user_type)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">User Type</p>
                                        <p>{{ phonepeUpiData.user_type }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.verified_merchant)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Verified Merchant</p>
                                        <p>{{ formatBool(phonepeUpiData.verified_merchant) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Bank / IFSC -->
                        <div class="details-box address-details-box" *ngIf="hasBankSection">
                            <h5 class="details-heading"><i class="bi bi-bank"></i>Bank / IFSC</h5>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.ifsc)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">IFSC</p>
                                        <p>{{ phonepeUpiData.ifsc }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.bank)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Bank</p>
                                        <p>{{ phonepeUpiData.bank }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.bank_code)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Bank Code</p>
                                        <p>{{ phonepeUpiData.bank_code }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.branch)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Branch</p>
                                        <p>{{ phonepeUpiData.branch }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.city)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">City</p>
                                        <p>{{ phonepeUpiData.city }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.state)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">State</p>
                                        <p>{{ phonepeUpiData.state }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.district)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">District</p>
                                        <p>{{ phonepeUpiData.district }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.centre)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Centre</p>
                                        <p>{{ phonepeUpiData.centre }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.address)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Address</p>
                                        <p>{{ phonepeUpiData.address }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.contact)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Contact</p>
                                        <p>{{ phonepeUpiData.contact }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.micr)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">MICR</p>
                                        <p>{{ phonepeUpiData.micr }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.swift)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">SWIFT</p>
                                        <p>{{ phonepeUpiData.swift }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.iso3166)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">ISO 3166</p>
                                        <p>{{ phonepeUpiData.iso3166 }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Payment rails -->
                        <div class="details-box verification-status-box" *ngIf="hasPaymentRailsSection">
                            <h5 class="details-heading"><i class="bi bi-credit-card-2-front"></i>Payment Rails</h5>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.upi_enabled)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">UPI Enabled</p>
                                        <p>{{ formatBool(phonepeUpiData.upi_enabled) }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.neft_enabled)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">NEFT Enabled</p>
                                        <p>{{ formatBool(phonepeUpiData.neft_enabled) }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.imps_enabled)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">IMPS Enabled</p>
                                        <p>{{ formatBool(phonepeUpiData.imps_enabled) }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="hasValue(phonepeUpiData?.rtgs_enabled)">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">RTGS Enabled</p>
                                        <p>{{ formatBool(phonepeUpiData.rtgs_enabled) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Photo -->
                        <div class="details-box" *ngIf="hasPhoto">
                            <h5 class="details-heading"><i class="bi bi-image"></i>Photo</h5>
                            <div class="row">
                                <div class="col-12">
                                    <div class="detail-row photo-row">
                                        <img [src]="displayablePhotoUrl" alt="UPI profile photo" class="upi-photo" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="notes-section mt-3">
                            <div class="notes-header">
                                <i class="bi bi-journal-text"></i>
                                <span>Add Notes</span>
                            </div>
                            <div class="notes-content">
                                <textarea class="note-input" maxlength="300" placeholder="Notes" [(ngModel)]="notes"></textarea>
                                <div class="notes-footer">
                                    <span class="character-count">{{ notes.length }}/300</span>
                                    <button type="button" class="update-button" (click)="onUpdateNotesButtonClick()">
                                        Update Notes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
